import React,{useState} from 'react'
import styles from "./offer.module.css"
import img from "../assets/confirmation_number.png"
import {Card, Image,Form,Row,Col,Button,Carousel} from "react-bootstrap"
import { FaStar } from "react-icons/fa";

export default function Offer() {
    const [validated, setValidated] = useState(false);
  
    const handleSubmit = (event) => {
      const form = event.currentTarget;
      if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
      }
  
      setValidated(true);
    };

    const offers = [
      { img: img, discount: "25% OFF", heading: "on your next booking", desc: "Lorem Ipsum is simply dummy text..." },
      { img: img, discount: "50% OFF", heading: "on all services", desc: "Lorem Ipsum is simply dummy text..." },
      { img: img, discount: "30% OFF", heading: "first cleaning", desc: "Lorem Ipsum is simply dummy text..." },
    ];

  return (
    <div className={styles.containerOffer}>
        <Carousel>
        <Carousel.Item interval={1000}>
      <div className={styles.boxOffer}>
        <div className={styles.contenOffer}>
            <h4 className={styles.offfPar}>25% OFF</h4>
            <h6 className={styles.offerheading2}>on your next booking</h6>
            <p className={styles.offerheading3}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>

        </div>

        <div className={styles.contenOfferDiscount}>
          <FaStar style={{position:"absolute",top:0,left:0,color:"#66d6ff"}}/>
          <FaStar style={{position:"absolute",top:10,right:10,color:"#66d6ff"}} size={12}/>
          <FaStar style={{position:"absolute",top:10,right:60,color:"#66d6ff"}} size={10}/>
          <FaStar style={{position:"absolute",bottom:20,left:0,color:"#66d6ff"}}/>
          <FaStar style={{position:"absolute",bottom:10,right:10,color:"#66d6ff"}} size={12}/>
          <FaStar style={{position:"absolute",bottom:10,right:60,color:"#66d6ff"}} size={10}/>
            <Image src={img}/>
            <div className={styles.overlyOffer}>
                <h6 className={styles.usercode}>USE CODE</h6>
                <h6 className={styles.wel150}>WEL150</h6>
            </div>
        </div>
      </div>
      </Carousel.Item>

      <Carousel.Item interval={1000}>
      <div className={styles.boxOffer}>
        <div className={styles.contenOffer}>
            <h4 className={styles.offfPar}>25% OFF</h4>
            <h6 className={styles.offerheading2}>on your next booking</h6>
            <p className={styles.offerheading3}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>

        </div>

        <div className={styles.contenOfferDiscount}>
          <FaStar style={{position:"absolute",top:0,left:0,color:"#66d6ff"}}/>
          <FaStar style={{position:"absolute",top:10,right:10,color:"#66d6ff"}} size={12}/>
          <FaStar style={{position:"absolute",top:10,right:60,color:"#66d6ff"}} size={10}/>
          <FaStar style={{position:"absolute",bottom:20,left:0,color:"#66d6ff"}}/>
          <FaStar style={{position:"absolute",bottom:10,right:10,color:"#66d6ff"}} size={12}/>
          <FaStar style={{position:"absolute",bottom:10,right:60,color:"#66d6ff"}} size={10}/>
            <Image src={img}/>
            <div className={styles.overlyOffer}>
                <h6 className={styles.usercode}>USE CODE</h6>
                <h6 className={styles.wel150}>WEL150</h6>
            </div>
        </div>
      </div>
      </Carousel.Item>

      <Carousel.Item interval={1000}>
      <div className={styles.boxOffer}>
        <div className={styles.contenOffer}>
            <h4 className={styles.offfPar}>25% OFF</h4>
            <h6 className={styles.offerheading2}>on your next booking</h6>
            <p className={styles.offerheading3}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>

        </div>

        <div className={styles.contenOfferDiscount}>
          <FaStar style={{position:"absolute",top:0,left:0,color:"#66d6ff"}}/>
          <FaStar style={{position:"absolute",top:10,right:10,color:"#66d6ff"}} size={12}/>
          <FaStar style={{position:"absolute",top:10,right:60,color:"#66d6ff"}} size={10}/>
          <FaStar style={{position:"absolute",bottom:20,left:0,color:"#66d6ff"}}/>
          <FaStar style={{position:"absolute",bottom:10,right:10,color:"#66d6ff"}} size={12}/>
          <FaStar style={{position:"absolute",bottom:10,right:60,color:"#66d6ff"}} size={10}/>
            <Image src={img}/>
            <div className={styles.overlyOffer}>
                <h6 className={styles.usercode}>USE CODE</h6>
                <h6 className={styles.wel150}>WEL150</h6>
            </div>
        </div>
      </div>
      </Carousel.Item>

      </Carousel>

        <div className={styles.formBox}>

          <h5 style={{marginTop:10,fontFamily:"Inter, sans-serif"}}>Get In Touch dsdf</h5>
          
          <Form noValidate validated={validated} onSubmit={handleSubmit} style={{marginTop:12}}>
                <Row className="mb-3">
                  <Form.Group as={Col} md="12" controlId="validationCustom01">
                    <Form.Control
                      required
                      type="text"
                      placeholder="Name"
                      className={styles.inputBox}
                      style={{background:"transparent",border:"none",borderBottom:"1px solid #767676",borderRadius:0,fontFamily:"sans-serif",fontSize:14}}
                    />
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Form.Group as={Col} md="12" controlId="validationCustom01">
                    <Form.Control
                      required
                      type="text"
                      placeholder="Phone"
                      style={{background:"transparent",border:"none",borderBottom:"1px solid #767676",borderRadius:0,fontFamily:"sans-serif",fontSize:14}}
                    />
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Form.Group as={Col} md="12" controlId="validationCustom01">
                    <Form.Control
                      required
                      type="text"
                      placeholder="Email"
                      style={{background:"transparent",border:"none",borderBottom:"1px solid #767676",borderRadius:0,fontFamily:"sans-serif",fontSize:14}}
                    />
                  </Form.Group>
                </Row>

                <Button type="submit" className={"mx-auto d-block"} style={{background:"#fff",fontFamily:"Inter",border:"1px solid #66d6ff",color:"#66d6ff"}} >Quick Booking</Button>
              </Form>
        </div>
        </div>
  )
}
